import axios from 'axios';
import { loggedinUser } from '../index';
import { getAPIRootUrl } from '../index';

// This class handles all communication with the server

// export interface RestResponse {
//     ok: boolean;
//     body: string;
// }

export class Agent {

    private static agent: Agent;

    private readonly API_ROOT: string = getAPIRootUrl();
    //private readonly API_ROOT: string = 'https://betaapinikko.netpbx5.net/api'; //Test
    //private API_ROOT: string = 'http://localhost:57321/api'; //Test

    //private readonly TimeOut: number = 60000; //Test
    private readonly TimeOut: number = 6000;

    private token: string;

    //Get the agent instance. Ensures that it will be a singleton
    public static get GetAgent() {
        if (this.agent == null || this.agent === undefined) {
            this.agent = new Agent();
        }
        return this.agent;
    }

    // Get logged in user data 
    // Includes all info on the user and the user's subscription(s)
    // If successfull Loggedinuser action getallOK is called with the info
    public GetAll() {
        const url = '/loggedinuser';
        axios
            .get(this.API_ROOT + url + '/?api_token=' + this.token, { timeout: this.TimeOut })
            .then(function (resp) {
                try {
                    if (resp.status !== 200) {
                        console.log('Error in axios response');
                        loggedinUser.comError('Kommunikationsproblem (' + resp.statusText + ')');
                    } else {
                        loggedinUser.getallOK(resp.data);
                    }
                } catch (e) {
                    console.log('Exception: ' + e.toString());
                    loggedinUser.comError('Kommunikationsproblem (' + e.toString() + ')');
                }
            })
            .catch(function (err) {
                try {
                    if (err) {
                        loggedinUser.comError('Kommunikationsproblem (' + err + ')');
                    }
                } catch (e) {
                    console.log('Exception: ' + e.toString());
                }
            });
    }

    // Get surf amount from server
    // Used to update to latest info. Do not report errors.
    // If successfull SurfAmount action updateSurfAmount is called with the info
    public GetSurfAmount() {
        const url = '/loggedinuser/getsurf';
        axios
            .get(this.API_ROOT + url + '/?api_token=' + this.token, { timeout: this.TimeOut })
            .then(function (resp) {
                try {
                    if (resp.status !== 200) {
                        console.log('Error in axios response');
                        //loggedinUser.comError('Kommunikationsproblem (' + resp.statusText + ')');                    
                    } else {
                        loggedinUser.subscriptions.selectedSubscription.surfAmount.updateSurfAmount(resp.data);
                    }
                } catch (e) {
                    console.log('Exception: ' + e.toString());
                    //loggedinUser.comError('Kommunikationsproblem (' + e.toString() + ')');                
                }
            })
            .catch(function (err) {
                try {
                    if (err) {
                        //loggedinUser.comError('Kommunikationsproblem (' + err + ')');
                    }
                } catch (e) {
                    console.log('Exception: ' + e.toString());
                }
            });
    }

    // Do a login. 
    // If successfull Loggedinuser action loggedinOK is called with the user info
    public PostAuth(url: string, body: {}) {
        //const url = '/Account/Login';
        axios
            .post(this.API_ROOT + url, body, { timeout: this.TimeOut })
            .then(function (resp) {
                try {
                    if (resp.status !== 200) {
                        console.log('Error in axios response');
                        loggedinUser.loggedinFail('Felaktig inloggning');
                    } else {
                        Agent.GetAgent.token = resp.data.API_Token;
                        loggedinUser.loggedinOK(resp.data);
                    }
                } catch (e) {
                    console.log('Exception: ' + e.toString());
                    loggedinUser.comError('Kommunikationsproblem (' + e.toString() + ')');
                }
            })
            .catch(function (err) {
                try {
                    if (err && err.response) {
                        if (err.response.status === 401) {
                            loggedinUser.loggedinFail('Felaktig inloggning'); //('Felaktigt lösenord');
                        } else {
                            if (err.response.status === 404) {
                                loggedinUser.loggedinFail('Felaktigt mobilnummer eller e-post adress');
                            } else {
                                loggedinUser.comError('Kommunikationsproblem (' + err + ')');
                            }
                        }
                    } else {
                        loggedinUser.comError('Kommunikationsproblem (' + err + ')');
                    }
                } catch (e) {
                    console.log('Exception: ' + e.toString());
                    loggedinUser.comError('Kommunikationsproblem (' + e.toString() + ')');
                }
            });
    }

    // Get branding texts from the server
    // Called early at startup to get texts for BrandingProps
    public GetBrandingText(brand: string) {
        console.log('agent.GetBrandingText');
        //const url = '/branding';
        const url = '/brand/mypages'; //new api
        axios
            .get(this.API_ROOT + url + '/?brand=' + brand, { timeout: this.TimeOut })
            .then(function (resp) {
                try {
                    if (resp.status !== 200) {
                        console.log('Error in axios response');
                        //loggedinUser.comError('Kommunikationsproblem (' + resp.statusText + ')');                    
                    } else if (resp.data) {
                        // We have data, store it
                        loggedinUser.branding.setBranding(resp.data);
                    }
                } catch (e) {
                    console.log('Exception: ' + e.toString());
                    //loggedinUser.comError('Kommunikationsproblem (' + e.toString() + ')');                
                }
            })
            .catch(function (err) {
                try {
                    if (err) {
                        console.log('Exception: ' + err);
                        //loggedinUser.comError('Kommunikationsproblem (' + err + ')');
                    }
                } catch (e) {
                    console.log('Exception: ' + e.toString());
                }
            });
    }
}


// WEBPACK FOOTER //
// ./src/stores/agent.ts